var map = {
	"./on.activity.svg": "./src/assets/icons/on.activity.svg",
	"./on.chart.svg": "./src/assets/icons/on.chart.svg",
	"./on.home.svg": "./src/assets/icons/on.home.svg",
	"./on.profile.svg": "./src/assets/icons/on.profile.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/on\\..*$";